if (!customElements.get('fw-calendar-duo')) {
  class FantasywandCalendarDuo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.variantSection?.addEventListener('variant:update', this.onVariantUpdate);
        return;
      }
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-duo-data]').textContent);
      this.data.mugs = this.data.mugs.filter(m => !m.requiresUpload);
      this.calendar = this.querySelector('[data-duo-calendar]');
      this.calendarVariant = this.querySelector('[data-duo-calendar-variant]');
      this.mug = this.querySelector('[data-duo-mug]');
      this.mugVariant = this.querySelector('[data-duo-mug-variant]');
      this.button = this.querySelector('[data-duo-add]');
      this.error = this.querySelector('[data-duo-error]');
      this.money = new Intl.NumberFormat('de-DE', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.data.calendars.forEach(c => { if (![...this.calendar.options].some(o => o.value === String(c.id))) this.calendar.add(new Option(c.title, String(c.id))); });
      this.data.mugs.forEach(m => this.mug.add(new Option(m.title, String(m.id))));
      if (this.dataset.kind === 'Tasse' && this.data.mugs.some(m => String(m.id) === this.dataset.current)) this.mug.value = this.dataset.current;
      else this.matchMug();
      this.populate(this.calendarVariant, this.calendarProduct());
      this.populate(this.mugVariant, this.mugProduct());
      const currentSelect = this.dataset.kind === 'Tasse' ? this.mugVariant : this.calendarVariant;
      if ([...currentSelect.options].some(o => o.value === this.dataset.variant && !o.disabled)) currentSelect.value = this.dataset.variant;
      if (window.location.hash === '#fw-calendar-duo') this.querySelector('details').open = true;
      this.calendar.addEventListener('change', () => {
        this.populate(this.calendarVariant, this.calendarProduct());
        if (this.dataset.kind !== 'Tasse' && !this.mugChosen) { this.matchMug(); this.populate(this.mugVariant, this.mugProduct()); }
        this.update();
      });
      this.mug.addEventListener('change', () => { this.mugChosen = true; this.populate(this.mugVariant, this.mugProduct()); this.update(); });
      this.calendarVariant.addEventListener('change', () => this.update());
      this.mugVariant.addEventListener('change', () => this.update());
      this.button.addEventListener('click', () => this.add());
      this.variantSection = this.closest('.shopify-section');
      this.onVariantUpdate = (event) => {
        if (String(event.detail.data.productId) !== this.dataset.current) return;
        const product = this.dataset.kind === 'Tasse' ? this.mugProduct() : this.calendarProduct();
        const select = this.dataset.kind === 'Tasse' ? this.mugVariant : this.calendarVariant;
        const variant = product?.variants.find(v => String(v.id) === String(event.detail.resource?.id));
        if (String(product?.id) !== this.dataset.current || !variant?.available) return;
        select.value = String(variant.id);
        this.update();
      };
      this.variantSection?.addEventListener('variant:update', this.onVariantUpdate);
      this.update();
    }
    disconnectedCallback() {
      this.variantSection?.removeEventListener('variant:update', this.onVariantUpdate);
    }
    calendarProduct() { return this.data.calendars.find(p => String(p.id) === this.calendar.value); }
    mugProduct() { return this.data.mugs.find(p => String(p.id) === this.mug.value); }
    populate(select, product) {
      select.replaceChildren();
      if (!product) return;
      product.variants.forEach(v => { const option = new Option(`${v.title} · ${this.money.format(v.price / 100)}`, String(v.id)); option.disabled = !v.available; select.add(option); });
      const available = product.variants.find(v => v.available);
      if (available) select.value = String(available.id);
    }
    matchMug() {
      const handle = this.calendarProduct()?.handle || '';
      const target = handle === 'tier-selfies-kalender-2027' ? 'wuetende-bettkatze-tasse-mit-spruch-sf261024-006' : handle === 'tierisch-frech-kalender-2027' ? 'muskelwolf-mit-mittelfinger-tasse-mit-spruch-sf261024-024' : handle.includes('suesse-tierfreunde') ? 'erdbeer-kuss-schildkroete-tasse' : handle.includes('suesse-tiere') ? 'blubber-alarm-axolotl-tasse' : handle.includes('halloween') ? 'der-geisterhund-tasse' : handle.includes('wikinger') ? 'vor-dem-thron-tasse' : handle.includes('ritter') ? 'der-seerosenteich-tasse' : 'drachenkoenigin-tasse';
      const product = this.data.mugs.find(m => m.handle === target);
      if (product) this.mug.value = String(product.id);
    }
    selected() {
      const calendar = this.calendarProduct(), mug = this.mugProduct();
      return {calendar, mug, cv:calendar?.variants.find(v => String(v.id) === this.calendarVariant.value), mv:mug?.variants.find(v => String(v.id) === this.mugVariant.value)};
    }
    update() {
      const {calendar,mug,cv,mv} = this.selected();
      const draft = calendar?.published === false || mug?.published === false;
      this.button.disabled = !(cv?.available && mv?.available) || draft;
      this.button.textContent = draft ? this.dataset.draft : this.dataset.submit;
      if (!cv || !mv) return;
      this.querySelector('[data-duo-total]').textContent = this.money.format((cv.price + mv.price) / 100);
      this.querySelector('[data-duo-prices]').textContent = `${calendar.title}: ${this.money.format(cv.price / 100)} · ${mug.title}: ${this.money.format(mv.price / 100)}`;
      for (const [selector,p,v] of [['[data-duo-calendar-image]',calendar,cv],['[data-duo-mug-image]',mug,mv]]) {const image=this.querySelector(selector); image.src=v.image || p.image; image.alt=`${p.title} – ${v.title}`;}
      this.querySelector('[data-duo-care]').textContent = mv.sku.endsWith('-BE') ? this.dataset.magic : this.dataset.care;
      this.error.hidden = true;
    }
    async add() {
      const {cv,mv} = this.selected();
      if (!cv?.available || !mv?.available || this.button.disabled) return;
      this.button.disabled = true; this.button.textContent = this.dataset.busy; this.error.hidden = true;
      try {
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:cv.id,quantity:1},{id:mv.id,quantity:1}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        if (result.items?.length !== 2) throw new Error(this.dataset.error);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error; this.error.hidden = false; this.button.disabled = false; this.button.textContent = this.dataset.submit;
      }
    }
  }
  customElements.define('fw-calendar-duo', FantasywandCalendarDuo);
}
